import { FavouriteSearch } from 'app/area/favourite/components/favourite-search';
import { FavouriteTitle } from 'app/area/favourite/components/favourite-title';
import { FavouriteReportDownload } from 'app/area/favourite/types';
import { DefaultSortOrder, FavouriteDefinition, SharedState } from 'app/types-shared';
import * as React from 'react';

import styles from './favourite.scss';
import { DomainNode } from 'ui/sort-order/types';

interface FavouriteHeaderProps {
  definition: FavouriteDefinition;
  searchQueryTemp: string;
  translation: any;
  sharedState: SharedState;
  fetchingSortOptions: boolean;
  onChange: (value: string) => void;
  onSearch: () => void;
  loadSortOptions: (query?: string) => void;
  updateSortOptions: (sortOrderFields: DefaultSortOrder[]) => void;
  displayExportToZip: () => void;
  onCreateReport: () => void;
  onUpdateReport: () => void;
  downloadReport: (data: FavouriteReportDownload) => void;
  getMultipleSuppliersUrl: () => void;
  urlMultipleSuppliers: string;
  report: number;
  favouriteId: number;
  reportCategory: any;
  sortOptions: DomainNode[];
  showUpdate: boolean;
  sortOrderFields?: DefaultSortOrder[];
}

export const FavouriteHeader = ({
  definition,
  translation,
  searchQueryTemp,
  sharedState,
  fetchingSortOptions,
  onChange,
  onSearch,
  loadSortOptions,
  updateSortOptions,
  displayExportToZip,
  onCreateReport,
  onUpdateReport,
  downloadReport,
  getMultipleSuppliersUrl,
  urlMultipleSuppliers,
  report,
  reportCategory,
  sortOptions,
  favouriteId,
  showUpdate,
  sortOrderFields
}: FavouriteHeaderProps) => (
  <div className={styles.searchHeader}>
    <div className="container main-grid">
      <FavouriteTitle 
        translation={translation}
        definition={definition}
      />
      <FavouriteSearch 
        searchQueryTemp={searchQueryTemp}
        translation={translation}
        sharedState={sharedState}
        fetchingSortOptions={fetchingSortOptions}
        onChange={onChange}
        onSearch={onSearch}
        loadSortOptions={loadSortOptions}
        updateSortOptions={updateSortOptions}
        displayExportToZip={displayExportToZip}
        onCreateReport={onCreateReport}
        onUpdateReport={onUpdateReport}
        downloadReport={downloadReport}
        getMultipleSuppliersUrl={getMultipleSuppliersUrl}
        urlMultipleSuppliers={urlMultipleSuppliers}
        report={report}
        reportCategory={reportCategory}
        sortOptions={sortOptions}
        favouriteId={favouriteId}
        showUpdate={showUpdate}
        sortOrderFields={sortOrderFields}
      />
    </div>
  </div>
);
